
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eiCiP", function(module, exports) {

$parcel$export(module.exports, "preloadLocalStorage", () => $ce9420cf2e1537b9$export$aa71e886f3713f68);

var $jLfE2 = parcelRequire("jLfE2");

var $e9zUf = parcelRequire("e9zUf");
async function $ce9420cf2e1537b9$export$aa71e886f3713f68() {
    const { userId: userId, isLicensed: isLicensed } = await (0, $jLfE2.getPreloaderFnContext)();
    return (0, $e9zUf.getRemoteLocalStorage)({
        userId: userId,
        isLicensed: isLicensed
    });
}

});

parcelRegister("iaqHp", function(module, exports) {

$parcel$export(module.exports, "EditorPreferencesQuery", () => $9457204073002f2c$export$d3ae3078a0689540);

var $d2LG0 = parcelRequire("d2LG0");
const $9457204073002f2c$export$d3ae3078a0689540 = (0, $d2LG0.default)`query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}`;

});

parcelRegister("iUV81", function(module, exports) {

$parcel$export(module.exports, "preloadLivePageRoute", () => $9ca0f3e234cc6f7f$export$b30d199cd0e05754);
parcelRequire("furnK");
var $7WOVi = parcelRequire("7WOVi");

var $3e0r1 = parcelRequire("3e0r1");

var $iV8Fk = parcelRequire("iV8Fk");

var $fyUox = parcelRequire("fyUox");

var $1i2qc = parcelRequire("1i2qc");

var $9wGTI = parcelRequire("9wGTI");

var $kZZXz = parcelRequire("kZZXz");

var $93jhx = parcelRequire("93jhx");

var $cvj7x = parcelRequire("cvj7x");

var $7tT2b = parcelRequire("7tT2b");

var $d9tcB = parcelRequire("d9tcB");

var $jLfE2 = parcelRequire("jLfE2");
var $kkLBe = parcelRequire("kkLBe");
var $lyWac = parcelRequire("lyWac");

var $9ycGg = parcelRequire("9ycGg");

var $lcQ5b = parcelRequire("lcQ5b");

var $5SzHz = parcelRequire("5SzHz");

var $gBI6h = parcelRequire("gBI6h");

var $lt4mJ = parcelRequire("lt4mJ");

var $eSLr0 = parcelRequire("eSLr0");

var $5Rwa0 = parcelRequire("5Rwa0");

var $cm3dv = parcelRequire("cm3dv");

var $28DDG = parcelRequire("28DDG");

var $gDMf3 = parcelRequire("gDMf3");

var $guO0R = parcelRequire("guO0R");

var $fNrAc = parcelRequire("fNrAc");

var $8CHHT = parcelRequire("8CHHT");

var $7Ndnw = parcelRequire("7Ndnw");

var $2WwwU = parcelRequire("2WwwU");

var $ePnB5 = parcelRequire("ePnB5");

var $1swiX = parcelRequire("1swiX");

var $kM8fE = parcelRequire("kM8fE");

var $dpyxe = parcelRequire("dpyxe");
const $9ca0f3e234cc6f7f$export$b30d199cd0e05754 = async (match, url)=>{
    const { isLicensed: isLicensed, userId: userId, edition: edition, cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, isAdminHubAIEnabled: isAdminHubAIEnabled, isRovoEnabled: isRovoEnabled, isRovoLLMEnabled: isRovoLLMEnabled, environment: environment } = await (0, $jLfE2.getPreloaderFnContext)();
    const tasks = [];
    const { spaceKey: spaceKey, contentId: contentId } = match.params;
    const username = (0, $1swiX.getUsername)(match);
    const isEmbeddedConfluence = (0, $1swiX.getIsEmbeddedConfluence)(match);
    const isBlog = Boolean((0, $kM8fE.matchBlogPage)(url));
    const shouldPreloadNavigation = !isEmbeddedConfluence;
    // eslint-disable-next-line check-react-ssr-usage/no-react-ssr
    const isSSR = Boolean(undefined);
    if (isSSR || (0, $9wGTI.fg)('preload_live_page_data_transition')) (0, $9wGTI.fg)('confluence_live_pages_unified_query') ? tasks.push((0, $guO0R.preloadLivePageData)({
        userId: userId,
        contentId: contentId,
        spaceKey: spaceKey
    })) : tasks.push((0, $kkLBe.prepareGuardExceptionTask)('EditorData', ()=>(0, $cvj7x.preloadEditorData)({
            spaceKey: spaceKey,
            userId: userId,
            contentId: contentId,
            shouldPreloadMentionsProvider: true,
            useCache: false,
            cloudId: cloudId,
            isBlog: isBlog,
            isLivePage: true
        })));
    // 1. Byline and possibly content prerequisites
    tasks.push((0, $7WOVi.preloadContentHeader)({
        spaceKey: spaceKey,
        contentId: contentId,
        isLicensed: isLicensed,
        userId: userId,
        username: username,
        edition: edition,
        isPrevEditRoute: false,
        useNewContentTopper: true,
        isBlog: false,
        isLivePageRoute: true
    }).then((resultOrHasErrorBoolean)=>{
        if (typeof resultOrHasErrorBoolean === 'boolean') {
            if (resultOrHasErrorBoolean) return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
        } else {
            const { results: results, hasErrors: hasErrors } = resultOrHasErrorBoolean;
            if (!hasErrors) return results;
            return (0, $lcQ5b.preloadContentPrerequisites)(contentId, spaceKey);
        }
    }), (0, $lt4mJ.preloadLegacyBridge)({
        contentId: contentId,
        isBlog: isBlog
    }));
    if (!(0, $9wGTI.fg)('confluence_live_pages_unified_query')) tasks.push((0, $gBI6h.preloadPageStatusQuery)(contentId));
    if ((0, $9wGTI.fg)('confluence_preload_smartlink_live_page')) {
        const contentIdWithAri = `ari:cloud:confluence:${cloudId}:page/${contentId}`;
        tasks.push((0, $2WwwU.preloadContentSmartLinks)(contentIdWithAri, true));
    }
    // 2. Page title
    !(0, $9wGTI.fg)('confluence_live_pages_unified_query') && tasks.push((0, $fyUox.preloadPageTitleContentProperties)({
        contentId: contentId,
        spaceKey: spaceKey
    }));
    // 3. Space details
    !(0, $9wGTI.fg)('confluence_live_pages_unified_query') && tasks.push((0, $5SzHz.preloadSpaceDetail)(spaceKey));
    // 4. Content types header (object header)
    if ((0, $9wGTI.fg)('confluence_frontend_object_header')) tasks.push((0, $3e0r1.preloadContentTypesHeader)(contentId, (0, $9wGTI.fg)('confluence_frontend_object_header')));
    // 4a. Unified Share and Restrict Button
    if (!(0, $9wGTI.fg)('confluence_live_pages_unified_query') && (0, $9wGTI.fg)('confluence_frontend_usd_ssr')) tasks.push((0, $gDMf3.preloadShareAndRestrictButtonQuery)(contentId));
    // 5. Navigation and page tree
    if (shouldPreloadNavigation) tasks.push((0, $dpyxe.preloadNavigationTasks)(spaceKey, contentId, isLicensed, isBlog));
    // 6. Inline Comments
    if (match?.query.focusedCommentId) tasks.push((0, $kZZXz.preloadFocusedInlineComment)(match?.query.focusedCommentId, contentId));
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('inline-comments', match)) // when rendering an embedded confluence page, we do not want to preload inline comments if they are not requested via the allowlist features
    {
        if (!(0, $9wGTI.fg)('confluence_frontend_rm_preload_comment_highlights')) tasks.push((0, $93jhx.preloadInlineHighlights)(contentId));
    }
    // 7. Reactions
    if (!isEmbeddedConfluence || (0, $1swiX.hasEmbeddedAllowedFeatures)('page-reactions', match)) {
        // TODO: delete
        // Preload whether the server has enabled reactions at all to show placeholder
        tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
            contentId: contentId,
            location: (0, $eSLr0.ATL_PAGE_CONTENT_FOOTER_ACTIONS)
        }));
        // Preload reactions asynchronously so SSR won't wait for it
        // it's best effort preloading so if it preloads then we have the data, otherwise SPA can load it
        if ((0, $9wGTI.fg)('confluence_ssr_reactions_preload')) tasks.push((0, $9ycGg.preloadPageReactions)(contentId));
    }
    if (spaceKey && (0, $9wGTI.fg)('confluence_preload_blank_page_quick_actions')) tasks.push((0, $cm3dv.preloadSuggestedTemplateQuery)({
        spaceKey: spaceKey
    }));
    // 10. Stuff only needed for initial load
    tasks.push(// We only refresh token when it is about to expire.
    (0, $1i2qc.preloadMediaToken)(contentId));
    !(0, $9wGTI.fg)('confluence_live_pages_unified_query') && (0, $iV8Fk.preloadCustomHeaderAndFooter)(spaceKey);
    tasks.push((0, $5Rwa0.preloadWebPanelLocation)({
        contentId: contentId,
        location: (0, $eSLr0.ATL_GENERAL)
    }));
    // 11. Object Sidebar Control + AI Button
    if (isAdminHubAIEnabled) tasks.push((0, $28DDG.preloadAIFloatingContextMenu)(contentId, isBlog));
    // 12. Preload Loom button in Action Bar
    if ((accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS) && isLoggedIn) tasks.push((0, $7tT2b.preloadRecordLoomButton)({
        cloudId: cloudId,
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn,
        userId: userId,
        environment: environment
    }));
    // 13. Preload content-based AI enablement check
    if ((0, $9wGTI.fg)('confluence_ai_access_policy')) {
        const shouldShowRovo = (0, $9wGTI.fg)('rovo_use_rovo_llm_enabled_check') ? isRovoLLMEnabled : isRovoEnabled;
        if (isAdminHubAIEnabled || shouldShowRovo) tasks.push((0, $fNrAc.preloadUseIsAIEnabledForContentQuery)(contentId));
    }
    // 14. Preload forge extension manifest
    if ((0, $9wGTI.fg)('confluence_preload_forge_viewport_heights_editor')) tasks.push((0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_XEN_MACRO)
    }));
    if ((0, $9wGTI.fg)('confluence_frontend_ssr_empty_live_footer_comments')) // this query is needed for the new redesigned footer comment experience
    {
        if ((0, $9wGTI.fg)('confluence-frontend-redesigned-footer-comment')) tasks.push((0, $ePnB5.preloadFooterComments)(contentId));
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};

});
parcelRegister("furnK", function(module, exports) {

$parcel$export(module.exports, "preloadContentHeader", () => (parcelRequire("7WOVi")).preloadContentHeader);

var $7WOVi = parcelRequire("7WOVi");

});
parcelRegister("7WOVi", function(module, exports) {

$parcel$export(module.exports, "preloadContentHeader", () => $f78a51e3eee2d07c$export$4a035f320f010fac);

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $4vyfK = parcelRequire("4vyfK");

var $gvxhu = parcelRequire("gvxhu");

var $3D1KL = parcelRequire("3D1KL");



var $5rHrW = parcelRequire("5rHrW");

var $3Tnjq = parcelRequire("3Tnjq");

var $elrT8 = parcelRequire("elrT8");

var $4YUQE = parcelRequire("4YUQE");

var $btHtj = parcelRequire("btHtj");

var $kb8ij = parcelRequire("kb8ij");




var $9wGTI = parcelRequire("9wGTI");


var $72lVk = parcelRequire("72lVk");

var $80xNa = parcelRequire("80xNa");
function $f78a51e3eee2d07c$export$4a035f320f010fac({ spaceKey: spaceKey, contentId: contentId, isLicensed: isLicensed, userId: userId, username: username, edition: edition, isPrevEditRoute: isPrevEditRoute = false, useNewContentTopper: useNewContentTopper = false, isBlog: isBlog, isLivePageRoute: isLivePageRoute = false }) {
    const queries = [];
    if (!(0, $9wGTI.fg)('confluence_preload_favourite_button') || !isLivePageRoute) queries.push((0, $btHtj.preloadFavouriteButton)(contentId, userId));
    // We preload content header unconditionally but when page is restricted we don't
    // render the corresponding components, neither we use the result of preloading.
    // Hence mute the restriction errors on preloading to avoid unnecessary noise.
    // The mute logic is done in muteExpectedGraphQLErrors, here we just want to know if errors happened.
    let hasErrors = false;
    const checkHasGraphQLErrors = (result)=>{
        hasErrors = hasErrors || Boolean(result?.hasErrors);
        return result;
    };
    // Don't preload queries that will be updated by editor if previous route is edit_page
    if (!isPrevEditRoute) {
        queries.push((0, $dYU3e.query)({
            query: (0, $72lVk.ContentHeaderUnifiedQuery),
            variables: {
                contentId: contentId,
                spaceKey: spaceKey,
                versionOverride: null,
                embeddedContentRender: null,
                limit: (0, $80xNa.DEFAULT_CONTRIBUTORS_FETCH_LIMIT),
                useNewContentTopper: useNewContentTopper
            }
        }).then(checkHasGraphQLErrors), (0, $gvxhu.preloadBreadcrumbs)(spaceKey, contentId, false).then(checkHasGraphQLErrors));
        // Editor will preload the content state if it's a live page
        if (!isLivePageRoute) queries.push((0, $4YUQE.preloadRendererContentState)(contentId).then(checkHasGraphQLErrors));
        // SSR Grant Access Restrictions button
        // username is a legacy URL parameter that actually represents accountId in the grant access flow
        if (contentId && username) queries.push((0, $elrT8.preloadGrantAccessDialogData)(contentId, username));
        //unlike SPA, no need to check the route since preloadContentHeader is fired only when its VIEW_PAGE.
        const includeAncestors = edition === (0, $80xNa.CONFLUENCE_EDITION).FREE;
        queries.push((0, $3Tnjq.preloadPageRestrictionsQuery)(contentId, includeAncestors));
    }
    queries.push((0, $kb8ij.preloadWatchDialog)({
        contentId: contentId,
        isLicensed: isLicensed,
        userId: userId
    }));
    if ((0, $9wGTI.fg)('confluence_frontend_preload_edit_and_analytics')) {
        queries.push((0, $3D1KL.preloadEditButton)({
            spaceKey: spaceKey,
            contentId: contentId
        }));
        queries.push((0, $5rHrW.preloadContentAnalyticsViewers)(contentId).then(checkHasGraphQLErrors));
    }
    if (// eslint-disable-next-line confluence-feature-gating/no-preconditioning
    !isLivePageRoute && (0, $9wGTI.fg)('confluence_frontend_object_header') && (0, $9wGTI.fg)('confluence_frontend_preload_page_metadata_query')) // preload data for whether "unpublished changes" label should show in view page object header
    queries.push((0, $4vyfK.preloadWebItemLocation)({
        location: 'page.metadata.banner',
        contentId: contentId
    }));
    if ((0, $9wGTI.fg)('query_preloader_no_promise_all')) return (0, $lyWac.waitForAllReturnWhenError)(queries).then((errors)=>{
        return Boolean(errors || hasErrors);
    });
    else // eslint-disable-next-line check-preloaders/no-promise-all
    return Promise.all(queries).then((results)=>({
            hasErrors: hasErrors,
            results: results
        }));
}

});
parcelRegister("gvxhu", function(module, exports) {

$parcel$export(module.exports, "preloadBreadcrumbs", () => $c0495b8b74599d94$export$7191f20434421cbb);

var $dYU3e = parcelRequire("dYU3e");

var $bpoON = parcelRequire("bpoON");

var $6mKj3 = parcelRequire("6mKj3");
function $c0495b8b74599d94$export$7191f20434421cbb(spaceKey, contentId, skipContent = false) {
    if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $bpoON.BreadcrumbsQuery),
        variables: {
            spaceKey: spaceKey,
            contentId: contentId,
            skipContent: skipContent
        },
        // Must be preloaded with network only to get fresh data
        fetchPolicy: 'network-only'
    });
}

});

parcelRegister("3D1KL", function(module, exports) {

$parcel$export(module.exports, "preloadEditButton", () => $da246eeeea807732$export$ba72223e933caac5);

var $dYU3e = parcelRequire("dYU3e");

var $g9MzJ = parcelRequire("g9MzJ");

var $3U7Aq = parcelRequire("3U7Aq");
function $da246eeeea807732$export$ba72223e933caac5({ spaceKey: spaceKey, contentId: contentId = '' }) {
    // spaceKey will always be passed for both space overviews and view pages, but contentId is
    // distinct for the latter
    if (spaceKey && !contentId) return (0, $dYU3e.query)({
        query: (0, $3U7Aq.EditButtonWithSpaceKeyQuery),
        variables: {
            spaceKey: spaceKey
        }
    }).then(({ data: data })=>{
        if (data?.spaceHomepage?.id) (0, $dYU3e.writeQuery)({
            query: (0, $g9MzJ.EditButtonQuery),
            variables: {
                contentId: data?.spaceHomepage?.id
            },
            data: {
                content: data?.spaceHomepage ? {
                    nodes: [
                        {
                            ...data.spaceHomepage,
                            space: data?.space || null
                        }
                    ],
                    // @ts-ignore
                    __typename: 'PaginatedContentListWithChild'
                } : null
            }
        });
    });
    return (0, $dYU3e.query)({
        query: (0, $g9MzJ.EditButtonQuery),
        variables: {
            contentId: contentId
        }
    });
}

});
parcelRegister("3U7Aq", function(module, exports) {

$parcel$export(module.exports, "EditButtonWithSpaceKeyQuery", () => $ee90ac47ae313d97$export$ac261645e0d13bee);

var $d2LG0 = parcelRequire("d2LG0");
const $ee90ac47ae313d97$export$ac261645e0d13bee = (0, $d2LG0.default)`query EditButtonWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id key}spaceHomepage(spaceKey:$spaceKey){id type operations{operation targetType}metadata{frontend{fabricEditorSupported embedded collabService}}subType type}}`;

});


parcelRegister("5rHrW", function(module, exports) {

$parcel$export(module.exports, "preloadContentAnalyticsViewers", () => $e023a6d7dfd4d02c$export$1ca7520ec7e7778c);

var $dYU3e = parcelRequire("dYU3e");

var $6MMCZ = parcelRequire("6MMCZ");
const $e023a6d7dfd4d02c$export$1ca7520ec7e7778c = (contentId)=>(0, $dYU3e.query)({
        query: (0, $6MMCZ.ContentAnalyticsViewersUnifiedQuery),
        variables: {
            contentId: contentId
        }
    });

});
parcelRegister("6MMCZ", function(module, exports) {

$parcel$export(module.exports, "ContentAnalyticsViewersUnifiedQuery", () => $5f399fbfb30e8a45$export$d12532069f979b6b);

var $d2LG0 = parcelRequire("d2LG0");
const $5f399fbfb30e8a45$export$d12532069f979b6b = (0, $d2LG0.default)`query ContentAnalyticsViewersUnifiedQuery($contentId:ID!$fromDate:String){contentAnalyticsViewers(contentId:$contentId fromDate:$fromDate){count}user:confluence_atlassianUser(current:true){id confluence{permissionType}}}`;

});


parcelRegister("3Tnjq", function(module, exports) {

$parcel$export(module.exports, "preloadPageRestrictionsQuery", () => $9c352464269d89b9$export$112a35af77c910a7);

var $dYU3e = parcelRequire("dYU3e");

var $gYXuI = parcelRequire("gYXuI");

var $hL5Va = parcelRequire("hL5Va");
function $9c352464269d89b9$export$112a35af77c910a7(contentId, includeAncestors) {
    return (0, $dYU3e.query)({
        query: (0, $hL5Va.PageRestrictionsQuery),
        variables: {
            contentId: contentId,
            status: (0, $gYXuI.ALLOWED_CONTENT_STATUSES),
            includeAncestors: includeAncestors
        },
        // Must be preloaded with network only to get fresh data
        fetchPolicy: 'network-only'
    });
}

});

parcelRegister("elrT8", function(module, exports) {

$parcel$export(module.exports, "preloadGrantAccessDialogData", () => $5aaba4497ca7f117$export$57e3b4d699814923);

var $dYU3e = parcelRequire("dYU3e");

var $eZFA1 = parcelRequire("eZFA1");
function $5aaba4497ca7f117$export$57e3b4d699814923(contentId, accountId) {
    return (0, $dYU3e.query)({
        query: (0, $eZFA1.GrantAccessDialogLoaderQuery),
        variables: {
            contentId: contentId,
            accountId: accountId
        }
    });
}

});

parcelRegister("4YUQE", function(module, exports) {

$parcel$export(module.exports, "preloadRendererContentState", () => $211ceb0d96c4c9d7$export$b64510f17befad98);

var $dYU3e = parcelRequire("dYU3e");

var $e2cl6 = parcelRequire("e2cl6");

var $8SuT6 = parcelRequire("8SuT6");
async function $211ceb0d96c4c9d7$export$b64510f17befad98(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $e2cl6.RendererContentStateQuery),
        variables: {
            contentId: contentId,
            isDraft: false,
            format: (0, $8SuT6.GraphQLDateFormat).USER_FRIENDLY
        },
        fetchPolicy: 'network-only'
    });
}

});

parcelRegister("btHtj", function(module, exports) {

$parcel$export(module.exports, "preloadFavouriteButton", () => $16805ac3e1fad5e8$export$e9cb71d0e8e23bd3);

var $dYU3e = parcelRequire("dYU3e");

var $4xaWd = parcelRequire("4xaWd");
function $16805ac3e1fad5e8$export$e9cb71d0e8e23bd3(contentId, userId) {
    // skip preloading on SSR if user is not logged in
    if (!Boolean(userId)) return Promise.resolve({});
    return (0, $dYU3e.query)({
        query: (0, $4xaWd.FavouriteButtonQuery),
        variables: {
            contentId: contentId
        }
    });
}

});

parcelRegister("kb8ij", function(module, exports) {

$parcel$export(module.exports, "preloadWatchDialog", () => $55455580d8d27fff$export$cc2a3c9139245546);

var $dYU3e = parcelRequire("dYU3e");

var $hpr9b = parcelRequire("hpr9b");

var $jfg97 = parcelRequire("jfg97");
function $55455580d8d27fff$export$cc2a3c9139245546({ spaceKey: spaceKey, isLicensed: isLicensed = false, userId: userId, contentId: contentId }) {
    // do nothing if user is unlicensed, no userId is provided, or spaceKey and contentId are BOTH undefined
    if (!isLicensed || !userId || !spaceKey && !contentId) return Promise.resolve({});
    // the only scenario in which spaceKey is passed but contentId is not is in Space Overview via preloadGroupedButtons
    if (spaceKey && !contentId) return (0, $dYU3e.query)({
        query: (0, $jfg97.WatchDialogWithSpaceKeyQuery),
        variables: {
            spaceKey: spaceKey
        },
        fetchPolicy: 'network-only'
    }).then(({ data: data })=>{
        if (data?.spaceHomepage?.id) (0, $dYU3e.writeQuery)({
            query: (0, $hpr9b.getWatchDialogQuery)(),
            variables: {
                contentId: data?.spaceHomepage?.id
            },
            data: {
                singleContent: data?.spaceHomepage && data?.space ? {
                    currentUserIsWatching: data?.spaceHomepage?.currentUserIsWatching,
                    id: data?.spaceHomepage?.id,
                    space: data?.space,
                    type: data?.spaceHomepage?.type,
                    // @ts-ignore
                    __typename: 'Content'
                } : null
            }
        });
    });
    return (0, $dYU3e.query)({
        query: (0, $hpr9b.getWatchDialogQuery)(),
        variables: {
            contentId: contentId
        },
        // Must be preloaded with network only to get fresh data
        fetchPolicy: 'network-only'
    });
}

});
parcelRegister("jfg97", function(module, exports) {

$parcel$export(module.exports, "WatchDialogWithSpaceKeyQuery", () => $e02bf1541fc91dc0$export$18f5842cacb85b13);

var $d2LG0 = parcelRequire("d2LG0");
const $e02bf1541fc91dc0$export$18f5842cacb85b13 = (0, $d2LG0.default)`query WatchDialogWithSpaceKeyQuery($spaceKey:String!){space(key:$spaceKey){id key currentUser{isWatched isWatchingBlogs}operations{operation targetType}}spaceHomepage(spaceKey:$spaceKey){id type currentUserIsWatching}}`;

});




parcelRegister("3e0r1", function(module, exports) {

$parcel$export(module.exports, "preloadContentTypesHeader", () => $2593043c9801de6f$export$9da8ccc82535deaf);

var $dYU3e = parcelRequire("dYU3e");

var $6LsQQ = parcelRequire("6LsQQ");
function $2593043c9801de6f$export$9da8ccc82535deaf(contentId, useObjectHeader) {
    return (0, $dYU3e.query)({
        query: (0, $6LsQQ.ContentTypesHeaderQuery),
        variables: {
            contentId: contentId,
            useObjectHeader: useObjectHeader
        }
    });
}

});

parcelRegister("iV8Fk", function(module, exports) {

$parcel$export(module.exports, "preloadCustomHeaderAndFooter", () => $c05bed830e3069e7$export$87b3e636f25ecc1e);

var $dYU3e = parcelRequire("dYU3e");

var $k3bZO = parcelRequire("k3bZO");
function $c05bed830e3069e7$export$87b3e636f25ecc1e(spaceKey) {
    return (0, $dYU3e.query)({
        query: (0, $k3bZO.CustomHeaderAndFooterQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}

});

parcelRegister("1i2qc", function(module, exports) {

$parcel$export(module.exports, "preloadMediaToken", () => $ab4965c7462ff107$export$2d12daceb0197048);

var $dYU3e = parcelRequire("dYU3e");

var $1qiwK = parcelRequire("1qiwK");
const $ab4965c7462ff107$export$2d12daceb0197048 = async (contentId)=>{
    const response = await (0, $dYU3e.query)({
        query: (0, $1qiwK.MediaDownloadTokenQuery),
        variables: {
            contentId: contentId,
            status: [
                'current',
                'draft',
                'archived'
            ]
        }
    });
    return response;
};

});

parcelRegister("kZZXz", function(module, exports) {

$parcel$export(module.exports, "preloadFocusedInlineComment", () => $3c4fa9d66409cc04$export$2d90e27e1463a533);

var $dYU3e = parcelRequire("dYU3e");

var $8Ya23 = parcelRequire("8Ya23");
function $3c4fa9d66409cc04$export$2d90e27e1463a533(commentId, contentId) {
    return (0, $dYU3e.query)({
        query: (0, $8Ya23.FocusedInlineCommentQuery),
        variables: {
            commentId: commentId,
            contentId: contentId
        }
    });
}

});

parcelRegister("93jhx", function(module, exports) {

$parcel$export(module.exports, "preloadInlineHighlights", () => $7e608c1be8768508$export$a5027a999378f70);

var $dYU3e = parcelRequire("dYU3e");

var $6cOZv = parcelRequire("6cOZv");
function $7e608c1be8768508$export$a5027a999378f70(pageId) {
    return (0, $dYU3e.query)({
        query: (0, $6cOZv.InlineHighlightsQuery),
        variables: {
            pageId: pageId
        },
        fetchPolicy: 'network-only'
    });
}

});

parcelRegister("7tT2b", function(module, exports) {

$parcel$export(module.exports, "preloadRecordLoomButton", () => $147f74e0bc8a9b5a$export$da2224e4c5ce5572);

var $dYU3e = parcelRequire("dYU3e");

var $9wGTI = parcelRequire("9wGTI");

var $9O7xk = parcelRequire("9O7xk");

var $eatNG = parcelRequire("eatNG");

var $5Eo8k = parcelRequire("5Eo8k");

var $1xB62 = parcelRequire("1xB62");

var $5CUwy = parcelRequire("5CUwy");
async function $147f74e0bc8a9b5a$export$da2224e4c5ce5572({ cloudId: cloudId, accessStatus: accessStatus, isLoggedIn: isLoggedIn, userId: userId, environment: environment }) {
    const isLoomDisabled = (0, $5Eo8k.getIsLoomDisabled)({
        accessStatus: accessStatus,
        isLoggedIn: isLoggedIn
    });
    const isBetaEnabled = (0, $1xB62.getIsLoomBetaEnabled)(accessStatus);
    if (window['__SSR_LOOM_ENTRY_POINT__']) return Promise.resolve();
    if (isLoomDisabled) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    if (isBetaEnabled) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'BETA'
        };
        return Promise.resolve();
    }
    // For now, we have to do the Beta check first because `confluence_frontend_loom_cross_sell` is
    // not enabled on Beta sites
    if (!(0, $9wGTI.fg)('confluence_frontend_loom_cross_sell')) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    try {
        const { data: data } = await (0, $dYU3e.query)({
            query: (0, $eatNG.LicensedProductsQuery)
        });
        const isTenantLicensed = data?.confluence_tenantContext?.licensedProducts.some((product)=>product.productKey === 'loom' && product.licenseStatus === (0, $9O7xk.LicenseStatus).ACTIVE);
        const loomTenantProvisionStatus = isTenantLicensed ? (0, $5CUwy.LoomTenantProvisionStatus).PROVISIONED : (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED;
        if (loomTenantProvisionStatus === (0, $5CUwy.LoomTenantProvisionStatus).NOT_PROVISIONED) {
            window['__SSR_LOOM_ENTRY_POINT__'] = {
                entryPointVariant: 'CROSS_FLOW'
            };
            // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
            if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) window['__SSR_LOOM_ENTRY_POINT__'] = {
                entryPointVariant: 'DISABLED'
            };
            return Promise.resolve();
        }
    } catch  {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'CROSS_FLOW',
            error: true
        };
        // if entry point variant is "CROSS_FLOW" but FF is enabled, return "DISABLED"
        if ((0, $9wGTI.fg)('confluence_frontend_loom_cross_flow_ads_opt_out')) window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'DISABLED'
        };
        return Promise.resolve();
    }
    // tenant is provisioned at this point, switch to "CROSS_JOIN" and attempt permissions check
    window['__SSR_LOOM_ENTRY_POINT__'] = {
        entryPointVariant: 'CROSS_JOIN'
    };
    // PERMISSIONS CHECK
    const loomUserPermissionStatus = await (0, $5CUwy.getLoomUserPermissionStatus)(cloudId, userId, environment);
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).NOT_PERMITTED) // if not permitted, entryPointVariant is already 'CROSS_JOIN' so resolve promise
    return Promise.resolve();
    if (loomUserPermissionStatus === (0, $5CUwy.LoomUserPermissionStatus).ERROR) {
        window['__SSR_LOOM_ENTRY_POINT__'] = {
            entryPointVariant: 'CROSS_JOIN',
            error: true
        };
        return Promise.resolve();
    }
    window['__SSR_LOOM_ENTRY_POINT__'] = {
        entryPointVariant: 'CO_USE'
    };
    return Promise.resolve();
}

});
parcelRegister("5Eo8k", function(module, exports) {

$parcel$export(module.exports, "getIsLoomDisabled", () => $613de45c1bdfbc89$export$2e09de8d75f18000);

var $lzcvT = parcelRequire("lzcvT");

var $8dwdz = parcelRequire("8dwdz");

var $d9tcB = parcelRequire("d9tcB");
const $613de45c1bdfbc89$export$2e09de8d75f18000 = ({ accessStatus: accessStatus, isLoggedIn: isLoggedIn })=>{
    const isInFedRamp = (0, $lzcvT.isFedRamp)();
    const isMobile = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    const isLicensed = accessStatus == (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus == (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    if (!isLoggedIn || !isLicensed) return true;
    if (isInFedRamp) return true;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    if (isMobile) return true;
    return false;
};

});

parcelRegister("1xB62", function(module, exports) {

$parcel$export(module.exports, "getIsLoomBetaEnabled", () => $9f6d8fef975ab9be$export$3380c638fe82cae3);

var $9wGTI = parcelRequire("9wGTI");

var $d9tcB = parcelRequire("d9tcB");

var $8dwdz = parcelRequire("8dwdz");
const $9f6d8fef975ab9be$export$3380c638fe82cae3 = (accessStatus)=>{
    const isConfluenceLicensed = accessStatus === (0, $d9tcB.AccessStatus).LICENSED_ADMIN_ACCESS || accessStatus === (0, $d9tcB.AccessStatus).LICENSED_USE_ACCESS;
    // don't enable entry points if user is on a mobile device or viewing mobile web
    const isMobileDeviceOrMobileWeb = (0, $8dwdz.isMobileUserAgent)() || (0, $8dwdz.shouldShowMobileWeb)();
    return isConfluenceLicensed && !isMobileDeviceOrMobileWeb && (0, $9wGTI.fg)('confluence_loom_beta_enabled');
};

});


parcelRegister("kkLBe", function(module, exports) {

$parcel$export(module.exports, "prepareGuardExceptionTask", () => $b973d0b9aa217224$export$53a56b40d8963332);

var $9WAeG = parcelRequire("9WAeG");
const $b973d0b9aa217224$export$14621363d65ac00 = [];
const $b973d0b9aa217224$export$53a56b40d8963332 = async (queryName, task)=>{
    const wrappedTask = (0, $9WAeG.SSRMeasures).run(`ssr-app/prepare/preloadQuery/guardException:${queryName}`, task);
    $b973d0b9aa217224$export$14621363d65ac00.push(wrappedTask);
    return wrappedTask;
};

});

parcelRegister("9ycGg", function(module, exports) {

$parcel$export(module.exports, "preloadPageReactions", () => $8ac918fba64f5f59$export$de4621222fb13b43);

var $dYU3e = parcelRequire("dYU3e");

var $3V1KT = parcelRequire("3V1KT");
function $8ac918fba64f5f59$export$de4621222fb13b43(pageId) {
    return (0, $dYU3e.query)({
        query: (0, $3V1KT.ReactionsContentQuery),
        variables: {
            contentId: pageId
        }
    });
}

});

parcelRegister("lcQ5b", function(module, exports) {

$parcel$export(module.exports, "preloadContentPrerequisites", () => $dbc6a71de2a3ffc4$export$22caa92111fd8d1d);

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $1cxtL = parcelRequire("1cxtL");

var $aZE1d = parcelRequire("aZE1d");
const $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery = (contentId, spaceKey)=>(0, $dYU3e.query)({
        query: (0, $1cxtL.ContentPrerequisitesQuery),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            missingSpaceKey: !spaceKey,
            spaceKey: spaceKey
        }
    });
const $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery = ({ contentId: contentId, versionOverride: versionOverride })=>(0, $dYU3e.query)({
        query: (0, $aZE1d.ContentRedirectQuery),
        errorPolicy: 'all',
        variables: {
            contentId: contentId,
            versionOverride: versionOverride
        }
    });
const $dbc6a71de2a3ffc4$export$22caa92111fd8d1d = (contentId, spaceKey, // Note: Add new function parameters/arguments to namedArgs below please! More than 3-4 unnamed function arguments makes it noticeably harder to comprehend the function calls.
namedArgs)=>{
    return (0, $lyWac.waitForAllReturnWhenError)([
        $dbc6a71de2a3ffc4$var$preloadContentPrerequisitesQuery(contentId, spaceKey),
        $dbc6a71de2a3ffc4$var$preloadContentRedirectQuery({
            contentId: contentId,
            ...namedArgs
        })
    ]);
};

});

parcelRegister("gBI6h", function(module, exports) {

$parcel$export(module.exports, "preloadPageStatusQuery", () => $8d43735f3bb06581$export$ad9216fbfde1ea82);

var $dYU3e = parcelRequire("dYU3e");

var $2reAc = parcelRequire("2reAc");
function $8d43735f3bb06581$export$ad9216fbfde1ea82(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $2reAc.PageStatusQuery),
        variables: {
            contentId: contentId
        }
    });
}

});
parcelRegister("2reAc", function(module, exports) {

$parcel$export(module.exports, "PageStatusQuery", () => $e70a6cae48f585f2$export$784933f26864b1a8);

var $d2LG0 = parcelRequire("d2LG0");
const $e70a6cae48f585f2$export$784933f26864b1a8 = (0, $d2LG0.default)`query PreloadPageStatusQuery($contentId:ID!){content(id:$contentId status:["archived" "current"]){nodes{id status}}}`;

});


parcelRegister("lt4mJ", function(module, exports) {

$parcel$export(module.exports, "preloadLegacyBridge", () => $66b1e969a9746f31$export$aca348026d93fa81);

var $dYU3e = parcelRequire("dYU3e");

var $iBlFo = parcelRequire("iBlFo");
async function $66b1e969a9746f31$export$aca348026d93fa81({ contentId: contentId, isBlog: isBlog }) {
    if (!contentId) return;
    return (0, $dYU3e.query)({
        query: (0, $iBlFo.LegacyBridgeQuery),
        variables: {
            contentId: contentId,
            isBlog: isBlog
        },
        errorPolicy: 'all'
    });
}

});
parcelRegister("iBlFo", function(module, exports) {

$parcel$export(module.exports, "LegacyBridgeQuery", () => $fbe6d71fe9219ecd$export$124d522ec607f357);

var $d2LG0 = parcelRequire("d2LG0");
const $fbe6d71fe9219ecd$export$124d522ec607f357 = (0, $d2LG0.default)`query PreloadLegacyBridgeQuery($contentId:ID!$isBlog:Boolean!){ptpage(id:$contentId status:[CURRENT])@skip(if:$isBlog){id nearestAncestors(first:1){edges{node{id title}}}}content(id:$contentId){nodes{id type title version{number}space{id key name type}operations{operation targetType}}}}`;

});


parcelRegister("5Rwa0", function(module, exports) {

$parcel$export(module.exports, "preloadWebPanelLocation", () => $9736b8942eb99a2e$export$fe7f338d767a5e6b);

var $dYU3e = parcelRequire("dYU3e");

var $8pvtc = parcelRequire("8pvtc");
function $9736b8942eb99a2e$export$fe7f338d767a5e6b(variables) {
    return (0, $dYU3e.query)({
        query: (0, $8pvtc.WebPanelLocationQuery),
        variables: variables
    });
}

});

parcelRegister("cm3dv", function(module, exports) {

$parcel$export(module.exports, "preloadSuggestedTemplateQuery", () => $143576df13bfa010$export$74ebc1a8d940775);

var $dYU3e = parcelRequire("dYU3e");

var $ae5hk = parcelRequire("ae5hk");

var $7ybiU = parcelRequire("7ybiU");

var $fDlC6 = parcelRequire("fDlC6");
function $143576df13bfa010$export$74ebc1a8d940775({ spaceKey: spaceKey }) {
    return (0, $dYU3e.query)({
        query: (0, $7ybiU.SuggestedTemplatesQuery),
        variables: {
            spaceKey: spaceKey,
            sortingScheme: (0, $ae5hk.SortOrders).RELEVANCY_SORT,
            limit: (0, $fDlC6.TEMPLATE_LIMIT)
        }
    });
}

});
parcelRegister("7ybiU", function(module, exports) {

$parcel$export(module.exports, "SuggestedTemplatesQuery", () => $28e0c476332cdb02$export$8e7a733df972d047);

var $d2LG0 = parcelRequire("d2LG0");
const $28e0c476332cdb02$export$8e7a733df972d047 = (0, $d2LG0.default)`query SuggestedTemplatesQuery($spaceKey:String!$sortingScheme:String$limit:Int!){allTemplates(spaceKey:$spaceKey sortingScheme:$sortingScheme limit:$limit){nodes{templateId contentBlueprintId blueprintModuleCompleteKey itemModuleCompleteKey templateType name description iconURL darkModeIconURL styleClass hasWizard isNew isPromoted isFavourite hasGlobalBlueprintContent categoryIds keywords recommendationRank author}}}`;

});


parcelRegister("28DDG", function(module, exports) {

$parcel$export(module.exports, "preloadAIFloatingContextMenu", () => $83b608e86b4ad2f7$export$6f71137e78694699);

var $dYU3e = parcelRequire("dYU3e");

var $kDPMK = parcelRequire("kDPMK");

var $c5UND = parcelRequire("c5UND");
function $83b608e86b4ad2f7$export$6f71137e78694699(contentId, isBlog) {
    const contentType = isBlog ? (0, $kDPMK.CatchupContentType).BLOGPOST : (0, $kDPMK.CatchupContentType).PAGE;
    return (0, $dYU3e.query)({
        query: (0, $c5UND.CatchupLastViewedTimeQuery),
        variables: {
            contentId: contentId,
            contentType: contentType
        }
    });
}

});

parcelRegister("gDMf3", function(module, exports) {

$parcel$export(module.exports, "preloadShareAndRestrictButtonQuery", () => $ef82cacd2239f1cb$export$be8d82af5bf2b0e);

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $gyneS = parcelRequire("gyneS");
async function $ef82cacd2239f1cb$export$be8d82af5bf2b0e(contentId) {
    const { isLoggedIn: isLoggedIn } = await (0, $jLfE2.getPreloaderFnContext)();
    if (!isLoggedIn) return;
    return (0, $dYU3e.query)({
        query: (0, $gyneS.ShareAndRestrictButtonQuery),
        variables: {
            contentId: contentId,
            isContentTypePublicLinkEligible: true
        }
    });
}

});

parcelRegister("guO0R", function(module, exports) {

$parcel$export(module.exports, "preloadLivePageData", () => $fcf64901f9c33eb1$export$1806ccc2683c4734);

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $eSLr0 = parcelRequire("eSLr0");

var $4vyfK = parcelRequire("4vyfK");

var $9OYfw = parcelRequire("9OYfw");

var $7Ndnw = parcelRequire("7Ndnw");

var $8CHHT = parcelRequire("8CHHT");

var $kDt9L = parcelRequire("kDt9L");

var $cRQNp = parcelRequire("cRQNp");

var $9wGTI = parcelRequire("9wGTI");

var $l1kdf = parcelRequire("l1kdf");

var $ep3GV = parcelRequire("ep3GV");
function $fcf64901f9c33eb1$export$1806ccc2683c4734({ userId: userId, contentId: contentId, spaceKey: spaceKey }) {
    const preloaders = [];
    // 1. Editor data
    // specific native collab editor queries
    if (!!contentId) {
        preloaders.push((0, $9OYfw.preloadCollabDraftContent)(contentId, '', false));
        preloaders.push((0, $kDt9L.preloadMentionsProvider)());
    }
    preloaders.push(// Pre-loading apps in the byline area for live pages. Currently only live pages have extension point apps and not classic editor.
    (0, $4vyfK.preloadWebItemLocation)({
        contentId: contentId,
        location: (0, $eSLr0.SYSTEM_CONTENT_BYLINE)
    }), // For some reason the addition of the filter (uses new Forge query) is causing SSR to timeout - workaround by skipping the filter
    (0, $8CHHT.preloadUseExtensionList)({
        spaceKey: spaceKey || '',
        moduleType: (0, $7Ndnw.FORGE_MODULE_BYLINE),
        skipFilter: true
    }));
    preloaders.push((0, $cRQNp.preloadReadTime)({
        contentId: contentId,
        useCache: false
    }));
    // 2. Unified data
    return (0, $lyWac.waitForAllReturnWhenError)([
        (0, $dYU3e.query)({
            query: (0, $ep3GV.LivePageUnifiedQuery),
            variables: {
                userId: userId,
                contentId: contentId,
                spaceKey: spaceKey,
                isUsdSsr: (0, $9wGTI.fg)('confluence_frontend_usd_ssr'),
                shouldIncludePermissionType: (0, $9wGTI.fg)('confluence_team_presence_general_availability')
            },
            fetchPolicy: 'network-only'
        }).then((response)=>{
            if (response.data) {
                const nativeCollabVariables = {
                    contentId: contentId,
                    status: [
                        'draft',
                        'current'
                    ]
                };
                (0, $dYU3e.writeQuery)({
                    query: (0, $l1kdf.NativeCollabQuery),
                    variables: nativeCollabVariables,
                    data: response.data
                });
            }
        }),
        ...preloaders
    ]);
}

});
parcelRegister("ep3GV", function(module, exports) {

$parcel$export(module.exports, "LivePageUnifiedQuery", () => $d29ac5937f517f1b$export$f82f67238df2612f);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $d29ac5937f517f1b$export$f82f67238df2612f = (0, $d2LG0.default)`query LivePageUnifiedQuery($userId:ID$contentId:ID!$spaceKey:String!$isUsdSsr:Boolean!$shouldIncludePermissionType:Boolean!){content(id:$contentId status:["current" "draft"]){nodes{id status type emojiTitlePublished:properties(key:"emoji-title-published"){nodes{id key value version{number}}}emojiTitleDraft:properties(key:"emoji-title-draft"){nodes{id key value version{number}}}contentProperties{latest{defaultTitleEmoji}}properties(key:"content-appearance-draft"){nodes{id key value version{number}}}metadata{frontend{coverPictureWidth}currentuser{favourited{isFavourite}}}contentState(isDraft:false){id name color restrictionLevel isCallerPermitted}contentStateLastUpdated(format:USER_FRIENDLY){value}operations{operation targetType}subType version{number ncsStepVersion by{type ...on KnownUser{accountId}...on User{accountId}}}labels{nodes{id name}}}}space(key:$spaceKey){id settings{customHeaderAndFooter{header{html js css spaUnfriendlyMacros{name}}footer{html js css spaUnfriendlyMacros{name}}}}}availableContentStates(contentId:$contentId){customContentStates{name color id}spaceContentStates{name color id restrictionLevel}}publicLinkPage(pageId:$contentId)@include(if:$isUsdSsr){pageId pageStatus}user:confluence_atlassianUser(id:$userId){id displayName photos{value isPrimary}confluence@include(if:$shouldIncludePermissionType){permissionType}}}`;

});


parcelRegister("fNrAc", function(module, exports) {

$parcel$export(module.exports, "preloadUseIsAIEnabledForContentQuery", () => $c5553e9027fa17eb$export$adbf5e356b5a0d01);

var $dYU3e = parcelRequire("dYU3e");

var $7mpOv = parcelRequire("7mpOv");
function $c5553e9027fa17eb$export$adbf5e356b5a0d01(contentId) {
    return (0, $dYU3e.query)({
        query: (0, $7mpOv.useIsAIEnabledForContentQuery),
        variables: {
            contentId: contentId
        }
    });
}

});

parcelRegister("2WwwU", function(module, exports) {

$parcel$export(module.exports, "preloadContentSmartLinks", () => $9eb88ac593a96a41$export$dc2d6742e80fba3c);

var $9WAeG = parcelRequire("9WAeG");

var $4VJDS = parcelRequire("4VJDS");

var $dYU3e = parcelRequire("dYU3e");

var $60cDW = parcelRequire("60cDW");
var $PrCoC = parcelRequire("PrCoC");

var $6mKj3 = parcelRequire("6mKj3");

var $3TtS2 = parcelRequire("3TtS2");

var $fBDCr = parcelRequire("fBDCr");

var $4ey0G = parcelRequire("4ey0G");

var $3mKlC = parcelRequire("3mKlC");

var $44css = parcelRequire("44css");
const $9eb88ac593a96a41$var$preloadContentSmartlinksQuery = async (contentId, isDraft = false)=>{
    if (isDraft) {
        const smartLinkDraftRes = await (0, $dYU3e.query)({
            query: (0, $4ey0G.ContentSmartLinksQueryForDraft),
            variables: {
                contentId: contentId
            }
        });
        return (0, $3TtS2.getSmartLinks)(smartLinkDraftRes, isDraft);
    }
    if ((0, $6mKj3.expVal)('use_outgoing_links_for_object_resolver_experiment', 'isEnabled', false)) {
        const outgoingLinksRes = await (0, $dYU3e.query)({
            query: (0, $3mKlC.OutgoingLinksQuery),
            variables: {
                contentId: contentId
            }
        });
        return (0, $3TtS2.getOutgoingLinks)(outgoingLinksRes);
    }
    const smartLinksRes = await (0, $dYU3e.query)({
        query: (0, $fBDCr.ContentSmartLinksQuery),
        variables: {
            contentId: contentId
        }
    });
    return (0, $3TtS2.getSmartLinks)(smartLinksRes, isDraft);
};
const $9eb88ac593a96a41$export$dc2d6742e80fba3c = async (contentId, isDraft = false)=>{
    const { customURLs: customURLs, userContext: userContext } = (0, $60cDW.getSSRRenderInputs)();
    // If we don't receive a URL - no reason to try and run queries
    let objectResolverURL = customURLs?.['object-resolver-service'];
    if (!objectResolverURL) return;
    // Call cc-graphql and get SmartLink URLs for the current page
    // begin marking blocking query time to determine remaining budget for ORS call
    const contentSmartLinksQueryStartTime = performance.now();
    const smartLinks = await $9eb88ac593a96a41$var$preloadContentSmartlinksQuery(contentId, isDraft);
    const contentSmartLinksQueryDuration = performance.now() - contentSmartLinksQueryStartTime;
    // If there are no valid SmartLinks on the page - exit
    if (!smartLinks?.length) return;
    // Save number of SmartLinks to send as BM Event
    window['__SSR_NUMBER_OF_SMARTLINKS__'] = smartLinks.length;
    // Send smart links to linking platform
    // EX: [{resourceUrl: "https://pug.jira-dev.com/wiki/people/team/3a9665f3-c92b-423a-88bd-9410c1180058"}]
    // If there is still budget remaining after ContentSmartLinksQuery to make an ORS call,
    // pass the remaining time as a param to the ORS resolver call
    const timeout = (0, $4VJDS.default).getNumber('confluence_ssr_preload_query_timeout', (0, $44css.DEFAULT_ORS_TIMEOUT));
    let errorBudgetForORSResolver = Math.round(timeout - contentSmartLinksQueryDuration);
    // Don't attempt to load anything as there's no time left, or the timeout is invalid
    if (typeof errorBudgetForORSResolver !== 'number' || errorBudgetForORSResolver <= 0) return;
    // If the calculated ORS time is greater than total timeout, set it to max value
    if (errorBudgetForORSResolver > timeout) errorBudgetForORSResolver = (0, $44css.MAX_ORS_TIME);
    objectResolverURL += `?timeout=${errorBudgetForORSResolver}`;
    return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/fetch:objectResolverService', async ()=>{
        try {
            const orsCalls = [];
            const limitedSmartlinks = smartLinks.slice(0, (0, $44css.MAX_BATCH_ORS_SMARTLINKS) * (0, $44css.MAX_CONCURRENT_ORS_CALLS));
            for(let i = 0; i < limitedSmartlinks.length; i += (0, $44css.MAX_BATCH_ORS_SMARTLINKS)){
                const chunk = limitedSmartlinks.slice(i, i + (0, $44css.MAX_BATCH_ORS_SMARTLINKS));
                orsCalls.push((0, $3TtS2.fetchORSForSSR)({
                    url: objectResolverURL,
                    body: JSON.stringify(chunk),
                    userContext: userContext
                }).then((orsRes)=>orsRes.json()));
            }
            // eslint-disable-next-line check-preloaders/no-promise-all
            const __SSR_SMARTLINKS__ = await Promise.all(orsCalls).then((responses)=>responses.flat());
            // Format response to fit SmartCard Provider storeOptions initial state
            const initialState = (0, $3TtS2.getInitialState)(__SSR_SMARTLINKS__);
            // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
            window['__SSR_SMARTLINKS__'] = initialState;
        } catch (e) {
            (0, $PrCoC.ssrPrepareErrorsClient).submitError(new Error(`ORS returned error on resolving SmartLinks: ${e.message}`));
        }
    });
};

});
parcelRegister("fBDCr", function(module, exports) {

$parcel$export(module.exports, "ContentSmartLinksQuery", () => $99684beea0cb5c0d$export$59ce7c771ac67509);

var $d2LG0 = parcelRequire("d2LG0");
const $99684beea0cb5c0d$export$59ce7c771ac67509 = (0, $d2LG0.default)`query ContentSmartLinksQuery($contentId:ID!){contentSmartLinks(id:$contentId){nodes{__typename url}}}`;

});

parcelRegister("4ey0G", function(module, exports) {

$parcel$export(module.exports, "ContentSmartLinksQueryForDraft", () => $b6b80acbb87afc82$export$96b224e3ba2405be);

var $d2LG0 = parcelRequire("d2LG0");
const $b6b80acbb87afc82$export$96b224e3ba2405be = (0, $d2LG0.default)`query confluence_contentSmartLinksForDraft($contentId:ID!){confluence_contentSmartLinksForDraft(id:$contentId){nodes{__typename url}}}`;

});

parcelRegister("3mKlC", function(module, exports) {

$parcel$export(module.exports, "OutgoingLinksQuery", () => $8b61f720787758d9$export$a0681264c37c98d4);

var $d2LG0 = parcelRequire("d2LG0");
const $8b61f720787758d9$export$a0681264c37c98d4 = (0, $d2LG0.default)`query OutgoingLinksQuery($contentId:ID!){content(id:$contentId){nodes{id outgoingLinks{externalOutgoingLinks{nodes{url}}internalOutgoingLinks{nodes{links{base webui}}}}}}}`;

});

parcelRegister("44css", function(module, exports) {

$parcel$export(module.exports, "MAX_BATCH_ORS_SMARTLINKS", () => $220a8b19e955ba29$export$ffce18f98c9480f1);
$parcel$export(module.exports, "MAX_CONCURRENT_ORS_CALLS", () => $220a8b19e955ba29$export$3a2785a7dfd1aa2e);
$parcel$export(module.exports, "DEFAULT_ORS_TIMEOUT", () => $220a8b19e955ba29$export$e936f5c5fb92f354);
$parcel$export(module.exports, "MAX_ORS_TIME", () => $220a8b19e955ba29$export$e5a7402adab9bb5d);
const $220a8b19e955ba29$export$ffce18f98c9480f1 = 5;
const $220a8b19e955ba29$export$3a2785a7dfd1aa2e = 3;
const $220a8b19e955ba29$export$e936f5c5fb92f354 = 500;
const $220a8b19e955ba29$export$e5a7402adab9bb5d = 300;

});


parcelRegister("ePnB5", function(module, exports) {

$parcel$export(module.exports, "preloadFooterComments", () => $a52f1fd1c70157af$export$430e678301eccf5d);

var $dYU3e = parcelRequire("dYU3e");

var $7W8i8 = parcelRequire("7W8i8");

var $f5Wgm = parcelRequire("f5Wgm");

var $eg9xl = parcelRequire("eg9xl");

var $9rE3H = parcelRequire("9rE3H");
const $a52f1fd1c70157af$var$logger = (0, $7W8i8.getLogger)('preloadFooterComments');
function $a52f1fd1c70157af$export$430e678301eccf5d(contentId, isArchived) {
    // Clear the cache BEFORE load. This query only every gets called with cache-only, so this prevents stale cache errors
    try {
        // On the server, we can sometimes fail to update the cache either at all, or at least in the expected order, which causes this query to look like it's forever loading
        (0, $dYU3e.writeQuery)({
            query: (0, $eg9xl.ActiveCommentsQuery),
            variables: (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(contentId, isArchived),
            data: {
                comments: {
                    nodes: [],
                    totalCount: -1,
                    __typename: 'PaginatedCommentList'
                }
            }
        });
    } catch (error) {
        // Do nothing, this is expected if the query is not in the cache
        $a52f1fd1c70157af$var$logger.error`Error clearing preload cache for footer comments for contentId: ${contentId}, error: ${error}`;
    }
    if (contentId) return (0, $dYU3e.query)({
        query: (0, $eg9xl.ActiveCommentsQuery),
        variables: (0, $9rE3H.buildConsistentActiveCommentsQueryPreloadVariables)(contentId, isArchived),
        fetchPolicy: 'network-only'
    }).then((response)=>{
        try {
            if (response.data && response.data?.totalCount === 0) // Only write to cache if there are no comments. This isn't strictly necessary - but simplifies our cache updates later on
            // Since we won't call the full query in this case
            (0, $dYU3e.writeQuery)({
                query: (0, $eg9xl.ActiveCommentsQuery),
                variables: (0, $9rE3H.buildConsistentActiveCommentsQueryVariables)({
                    pageId: contentId,
                    type: (0, $f5Wgm.CommentType).FOOTER,
                    isArchived: isArchived
                }),
                data: response.data
            });
        } catch (error) {
            $a52f1fd1c70157af$var$logger.error`Error writing to full cache for footer comments for contentId: ${contentId}, error: ${error}`;
        }
    });
    else return Promise.resolve({});
}

});

parcelRegister("1swiX", function(module, exports) {

$parcel$export(module.exports, "getIsEmbeddedConfluence", () => $2da08b1abbbb9472$export$914b80ef7b05e6be);
$parcel$export(module.exports, "hasEmbeddedAllowedFeatures", () => $2da08b1abbbb9472$export$b04bf7ed076c9866);
$parcel$export(module.exports, "getUsername", () => $2da08b1abbbb9472$export$204da773c0191bd8);
$parcel$export(module.exports, "shouldPreloadNavigationForTransition", () => $2da08b1abbbb9472$export$96d52eb4c89741b4);

var $1NBp8 = parcelRequire("1NBp8");
const $2da08b1abbbb9472$export$914b80ef7b05e6be = (match)=>!!(match?.query.embedded || match?.query.parentProduct);
const $2da08b1abbbb9472$export$b04bf7ed076c9866 = (feature, match)=>match?.query.initialAllowedFeatures?.indexOf(feature) || match?.query.initialAllowedFeatures === 'all';
const $2da08b1abbbb9472$export$204da773c0191bd8 = (match)=>{
    const username = match?.query.username;
    if (!username) return '';
    if (Array.isArray(username)) return username[0];
    return username;
};
const $2da08b1abbbb9472$export$96d52eb4c89741b4 = (previousMatch)=>previousMatch?.name === (0, $1NBp8.HOME).name || previousMatch?.name === (0, $1NBp8.ADVANCED_SEARCH).name || previousMatch?.name === (0, $1NBp8.SPACE_OVERVIEW).name;

});

parcelRegister("kM8fE", function(module, exports) {

$parcel$export(module.exports, "matchHome", () => $04e58c16bcbc1952$export$74e73cc91cadfbcb);
$parcel$export(module.exports, "matchLivePage", () => $04e58c16bcbc1952$export$9b5271c8016c128c);
$parcel$export(module.exports, "matchViewPage", () => $04e58c16bcbc1952$export$3e3db362037b34f);
$parcel$export(module.exports, "matchBlogPage", () => $04e58c16bcbc1952$export$192c834e0bea39fe);
$parcel$export(module.exports, "matchWhiteboardPage", () => $04e58c16bcbc1952$export$a5aebc3364387341);
$parcel$export(module.exports, "matchDatabasePage", () => $04e58c16bcbc1952$export$3f2440066ae1f23);
$parcel$export(module.exports, "matchEmbedPage", () => $04e58c16bcbc1952$export$b1c34ea376f57e50);
$parcel$export(module.exports, "matchSpaceOverview", () => $04e58c16bcbc1952$export$60329dc4f3d156ce);
$parcel$export(module.exports, "matchCompanyHub", () => $04e58c16bcbc1952$export$56eec48d64616d8b);
$parcel$export(module.exports, "matchFabricEditor", () => $04e58c16bcbc1952$export$3f29957b70348eca);
$parcel$export(module.exports, "matchEditBlog", () => $04e58c16bcbc1952$export$9449ab1a743aa4d4);
$parcel$export(module.exports, "matchExternalShare", () => $04e58c16bcbc1952$export$3ce40e86c460686d);
$parcel$export(module.exports, "matchSpacePages", () => $04e58c16bcbc1952$export$efe2eb904cd9c81a);
$parcel$export(module.exports, "matchContentHistory", () => $04e58c16bcbc1952$export$3c3929e91c626c02);
$parcel$export(module.exports, "matchEmbeddedEditor", () => $04e58c16bcbc1952$export$7c8524eeca3a9c2d);
$parcel$export(module.exports, "matchCreateContent", () => $04e58c16bcbc1952$export$b5c8ff5b11237476);
$parcel$export(module.exports, "matchPdfExport", () => $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e);

var $1NBp8 = parcelRequire("1NBp8");

var $9wGTI = parcelRequire("9wGTI");

var $9sGCn = parcelRequire("9sGCn");
const $04e58c16bcbc1952$export$74e73cc91cadfbcb = (url)=>(0, $1NBp8.BASE).match(url) || (0, $1NBp8.WIKI).match(url) || (0, $1NBp8.HOME).match(url);
const $04e58c16bcbc1952$export$9b5271c8016c128c = (url)=>{
    const viewMatch = (0, $1NBp8.VIEW_PAGE).match(url);
    const contentId = viewMatch?.params?.contentId;
    if (contentId && (0, $9wGTI.fg)('confluence_live_page_preload_livepage_route')) {
        const { subType: subType, isArchived: isArchived } = (0, $9sGCn.getCachedPageData)(contentId);
        if (subType === 'live' && !isArchived) return viewMatch;
    }
    return null;
};
const $04e58c16bcbc1952$export$3e3db362037b34f = (url)=>{
    return (0, $1NBp8.VIEW_PAGE).match(url) || $04e58c16bcbc1952$export$192c834e0bea39fe(url);
};
const $04e58c16bcbc1952$export$192c834e0bea39fe = (url)=>(0, $1NBp8.VIEW_BLOG).match(url) || (0, $1NBp8.VIEW_BLOG_DATE_LEGACY).match(url);
const $04e58c16bcbc1952$export$a5aebc3364387341 = (url)=>(0, $1NBp8.WHITEBOARD_BOARD).match(url);
const $04e58c16bcbc1952$export$3f2440066ae1f23 = (url)=>(0, $1NBp8.DATABASE_VIEW).match(url);
const $04e58c16bcbc1952$export$b1c34ea376f57e50 = (url)=>(0, $1NBp8.EMBED_VIEW).match(url);
const $04e58c16bcbc1952$export$60329dc4f3d156ce = (url)=>(0, $1NBp8.SPACE_OVERVIEW).match(url) || (0, $1NBp8.SPACE_INDEX).match(url);
const $04e58c16bcbc1952$export$56eec48d64616d8b = (url)=>(0, $1NBp8.COMPANY_HUB).match(url);
const $04e58c16bcbc1952$export$3f29957b70348eca = (url)=>(0, $1NBp8.EDIT_PAGE_V2).match(url) || (0, $1NBp8.EDIT_BLOG_V2).match(url) || (0, $1NBp8.COMPANY_HUB_EDIT).match(url);
const $04e58c16bcbc1952$export$9449ab1a743aa4d4 = (url)=>(0, $1NBp8.EDIT_BLOG_V2).match(url);
const $04e58c16bcbc1952$export$3ce40e86c460686d = (url)=>(0, $1NBp8.EXTERNAL_SHARE).match(url);
const $04e58c16bcbc1952$export$efe2eb904cd9c81a = (url)=>(0, $1NBp8.SPACE_PAGES).match(url);
const $04e58c16bcbc1952$export$3c3929e91c626c02 = (url)=>(0, $1NBp8.CONTENT_HISTORY).match(url);
const $04e58c16bcbc1952$export$7c8524eeca3a9c2d = (url)=>(0, $1NBp8.EDIT_PAGE_EMBED).match(url);
const $04e58c16bcbc1952$export$b5c8ff5b11237476 = (url)=>(0, $1NBp8.CREATE_CONTENT).match(url);
const $04e58c16bcbc1952$export$a2b8fd5ca9c2a95e = (url)=>(0, $1NBp8.PDF_EXPORT_PAGE).match(url);

});

parcelRegister("dpyxe", function(module, exports) {

$parcel$export(module.exports, "preloadNavigationTasks", () => $b40f909d573440e2$export$9a7c1b3da2b1bad4);

var $26oT8 = parcelRequire("26oT8");

var $8Csq9 = parcelRequire("8Csq9");

var $IGlEW = parcelRequire("IGlEW");

var $7A94k = parcelRequire("7A94k");

var $6anVB = parcelRequire("6anVB");

var $5iG5Q = parcelRequire("5iG5Q");

var $ivyMZ = parcelRequire("ivyMZ");

var $lyWac = parcelRequire("lyWac");
const $b40f909d573440e2$export$9a7c1b3da2b1bad4 = async (spaceKey, contentId, isLicensed, isBlog)=>{
    const tasks = [];
    tasks.push((0, $26oT8.preloadSpaceGuestList)(spaceKey), (0, $8Csq9.preloadShortcutsSmartLinks)(spaceKey), (0, $IGlEW.preloadSideNavigation)(spaceKey), (0, $IGlEW.preloadSideNavigationNeedsContentId)(spaceKey, contentId), (0, $7A94k.preloadSpaceViews)(spaceKey, isLicensed));
    tasks.push((0, $6anVB.preloadPageTree)({
        spaceKey: spaceKey,
        ...isBlog ? {} : {
            contentId: contentId
        },
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        isSuperAdmin: false
    }), (0, $5iG5Q.preloadBlogTree)({
        spaceKey: spaceKey
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};

});
parcelRegister("26oT8", function(module, exports) {

$parcel$export(module.exports, "preloadSpaceGuestList", () => $d0a9c91d619f4c3a$export$768c9c91046a1ca6);

var $dYU3e = parcelRequire("dYU3e");

var $6mKj3 = parcelRequire("6mKj3");

var $jW8MZ = parcelRequire("jW8MZ");
function $d0a9c91d619f4c3a$export$768c9c91046a1ca6(spaceKey) {
    if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $jW8MZ.ViewSpaceExternalCollaboratorsDialogQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
}

});

parcelRegister("8Csq9", function(module, exports) {

$parcel$export(module.exports, "preloadShortcutsSmartLinks", () => $7f218a294dcdf804$export$ce708b69aef66f83);
/* eslint-disable check-credentials-option/has-credentials-option */ /* eslint-disable no-restricted-syntax */ 
var $3TtS2 = parcelRequire("3TtS2");

var $dYU3e = parcelRequire("dYU3e");

var $60cDW = parcelRequire("60cDW");
var $PrCoC = parcelRequire("PrCoC");

var $4VJDS = parcelRequire("4VJDS");

var $eohUr = parcelRequire("eohUr");
const $7f218a294dcdf804$export$ce708b69aef66f83 = async (spaceKey)=>{
    const { customURLs: customURLs, userContext: userContext } = (0, $60cDW.getSSRRenderInputs)();
    // If we don't receive a URL - no reason to try and run queries
    let objectResolverURL = customURLs?.['object-resolver-service'];
    if (!objectResolverURL) return;
    const shortcutsSmartLinksQueryStartTime = performance.now();
    // Call cc-graphql and get SmartLink URLs for the current space's shortcuts
    const res = await (0, $dYU3e.query)({
        query: (0, $eohUr.SpaceShortcutsSpaceNavigationQuery),
        variables: {
            spaceKey: spaceKey
        }
    });
    const shortcutsSmartLinksQueryDuration = performance.now() - shortcutsSmartLinksQueryStartTime;
    // Loop through query data and pull out smart links
    const smartLinks = (0, $3TtS2.getSmartShortcuts)(res);
    // If there are no valid SmartLinks shortcuts - exit
    if (!smartLinks?.length) return;
    const timeout = (0, $4VJDS.default).getNumber('confluence_ssr_preload_query_timeout', 800);
    if (timeout) {
        let errorBudgetForORSResolver = Math.round(timeout - shortcutsSmartLinksQueryDuration);
        // Prevent errorBudgetForORSResolver to be a crazy large number
        if (errorBudgetForORSResolver > timeout) errorBudgetForORSResolver = timeout;
        if (errorBudgetForORSResolver > 0) objectResolverURL += `?timeout=${errorBudgetForORSResolver}`;
    }
    // Send smart links to linking platform
    try {
        const orsRes = await (0, $3TtS2.fetchORSForSSR)({
            url: objectResolverURL,
            userContext: userContext,
            body: JSON.stringify(smartLinks)
        });
        if (orsRes.ok) {
            const __SSR_SHORTCUTS__ = await orsRes.json();
            // Format response to fit SmartCard Provider storeOptions initial state
            // Save correctly formatted response to window obj so it can be used on SSR and SPA (no duplicate calls)
            window['__SSR_SHORTCUTS__'] = (0, $3TtS2.getInitialState)(__SSR_SHORTCUTS__);
        }
    } catch (e) {
        (0, $PrCoC.ssrPrepareErrorsClient).submitError(new Error(`Smart link shortcuts ORS call failed: ${e.message}`));
    }
};

});

parcelRegister("IGlEW", function(module, exports) {

$parcel$export(module.exports, "preloadSideNavigationNeedsContentId", () => $ffe798577d563302$export$ce0b0e0703c8ea78);
$parcel$export(module.exports, "preloadSideNavigation", () => $ffe798577d563302$export$f5bb385ed55e90ad);
parcelRequire("bFNdd");
var $cdE3K = parcelRequire("cdE3K");

var $9wGTI = parcelRequire("9wGTI");

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $8CHHT = parcelRequire("8CHHT");

var $7Ndnw = parcelRequire("7Ndnw");

var $4vyfK = parcelRequire("4vyfK");

var $1dnxO = parcelRequire("1dnxO");

var $6mKj3 = parcelRequire("6mKj3");

var $2fsJn = parcelRequire("2fsJn");

var $495vE = parcelRequire("495vE");

var $8q3aB = parcelRequire("8q3aB");
async function $ffe798577d563302$export$ce0b0e0703c8ea78(spaceKey, contentId) {
    if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) return Promise.resolve();
    return (0, $8CHHT.preloadUseExtensionList)({
        contentId: contentId,
        spaceKey: spaceKey,
        moduleType: (0, $7Ndnw.FORGE_MODULE_SPACE_PAGE)
    });
}
async function $ffe798577d563302$export$f5bb385ed55e90ad(spaceKey) {
    const preloadedSessionContext = await (0, $jLfE2.getPreloaderFnContext)();
    const isNav4Enabled = (0, $1dnxO.getIsNav4Enabled)();
    const tasks = [];
    if (!(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) tasks.push((0, $dYU3e.query)({
        query: (0, $8q3aB.SpaceNavigationQuery),
        variables: {
            spaceKey: spaceKey,
            isLicensed: preloadedSessionContext.isLicensed
        }
    }));
    tasks.push((0, $2fsJn.preloadPersistentInviteButtonEligible)({
        spaceKey: spaceKey
    }, (0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)));
    if (isNav4Enabled) {
        tasks.push((0, $4vyfK.preloadWebItemLocation)({
            location: 'system.header/left'
        }));
        tasks.push((0, $495vE.preloadEnhanceOrientationTour)());
    }
    if ((0, $9wGTI.fg)('po-connie-side-nav-ssr-shadow')) tasks.push((0, $cdE3K.preloadPostOfficeConfluenceSideNav)(preloadedSessionContext));
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
}

});
parcelRegister("bFNdd", function(module, exports) {

$parcel$export(module.exports, "preloadPostOfficeConfluenceSideNav", () => (parcelRequire("cdE3K")).preloadPostOfficeConfluenceSideNav);

var $cdE3K = parcelRequire("cdE3K");

});
parcelRegister("cdE3K", function(module, exports) {

$parcel$export(module.exports, "preloadPostOfficeConfluenceSideNav", () => $5983b7a8cf0f433d$export$5607995cc5080e70);

var $MyxIQ = parcelRequire("MyxIQ");

var $6mKj3 = parcelRequire("6mKj3");

var $9WAeG = parcelRequire("9WAeG");

var $lyWac = parcelRequire("lyWac");
const $5983b7a8cf0f433d$export$5607995cc5080e70 = async (preloadedSessionContext)=>{
    const tasks = [];
    const isLocaleEligible = preloadedSessionContext.locale.toLowerCase().startsWith('en');
    if (preloadedSessionContext.userId && isLocaleEligible && // Suppress exposure as this is not the true exposure point, check required to prevent unnecessary preloading
    // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    (0, $6mKj3.expValEqualsNoExposure)('post-office_expt_confluence-next-best-actions', 'cohort', 'variation')) {
        const preloadPostOfficeSideNav = async ()=>{
            return (0, $9WAeG.SSRMeasures).run('ssr-app/prepare/preloadQuery/postOffice:ConfluenceSideNav', async ()=>{
                return (0, $MyxIQ.preloadPostOfficePlacementWithSessionContext)('confluence-side-nav', preloadedSessionContext);
            });
        };
        tasks.push(preloadPostOfficeSideNav());
    }
    return (0, $lyWac.waitForAllReturnWhenError)(tasks);
};

});


parcelRegister("2fsJn", function(module, exports) {

$parcel$export(module.exports, "preloadPersistentInviteButtonEligible", () => $c17fd2752a43fba2$export$350d5cfce01a6908);

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $euL71 = parcelRequire("euL71");

var $9wGTI = parcelRequire("9wGTI");

var $5BKUr = parcelRequire("5BKUr");
async function $c17fd2752a43fba2$export$350d5cfce01a6908({ spaceKey: spaceKey }, skipSpaceQuery = false) {
    if ((0, $9wGTI.fg)('confluence_nav4_global-invite')) {
        const { edition: edition, isLicensed: isLicensed, userId: userId } = await (0, $jLfE2.getPreloaderFnContext)();
        const isFreeEdition = edition === (0, $euL71.ConfluenceEdition).FREE;
        return (0, $dYU3e.query)({
            query: (0, $5BKUr.PersistentInviteEligibleQuery),
            variables: {
                spaceKey: spaceKey,
                skipLicenseQuery: isFreeEdition || !isLicensed || !Boolean(userId) || skipSpaceQuery,
                skipSpaceQuery: !Boolean(spaceKey)
            }
        });
    }
}

});
parcelRegister("5BKUr", function(module, exports) {

$parcel$export(module.exports, "PersistentInviteEligibleQuery", () => $8f090db6c0dc0794$export$6987d8916b4890c6);

var $d2LG0 = parcelRequire("d2LG0");
const $8f090db6c0dc0794$export$6987d8916b4890c6 = (0, $d2LG0.default)`query PersistentInviteEligibleQuery($spaceKey:String$skipLicenseQuery:Boolean!$skipSpaceQuery:Boolean!){space(key:$spaceKey)@skip(if:$skipSpaceQuery){id currentUser{isAnonymouslyAuthorized}}license@skip(if:$skipLicenseQuery){licenseConsumingUserCount trialEndDate}}`;

});


parcelRegister("495vE", function(module, exports) {

$parcel$export(module.exports, "preloadEnhanceOrientationTour", () => $29d0e87112394d65$export$c5c5fb63d54c1d7a);

var $dYU3e = parcelRequire("dYU3e");

var $66UJS = parcelRequire("66UJS");

var $dojsn = parcelRequire("dojsn");
async function $29d0e87112394d65$export$c5c5fb63d54c1d7a() {
    return (0, $dYU3e.query)({
        query: (0, $66UJS.getOnboardingStateGQL),
        variables: {
            key: Object.values((0, $dojsn.ENHANCE_ORIENTATION_TOUR_ONBOARDING_STATE_KEYS))
        }
    });
}

});


parcelRegister("7A94k", function(module, exports) {

$parcel$export(module.exports, "preloadSpaceViews", () => $5600fd3490744a04$export$d5a6f6937168d07d);

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $6mKj3 = parcelRequire("6mKj3");

var $27YEi = parcelRequire("27YEi");

var $aGl35 = parcelRequire("aGl35");
function $5600fd3490744a04$export$d5a6f6937168d07d(spaceKey, isLicensed) {
    const queries = [];
    if (!(0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) queries.push((0, $dYU3e.query)({
        query: (0, $aGl35.SpaceRootQuery),
        variables: {
            spaceKey: spaceKey
        }
    }));
    if (isLicensed) queries.push((0, $dYU3e.query)({
        query: (0, $27YEi.PersistenceQuery),
        variables: {
            spaceKey: spaceKey
        }
    }));
    return (0, $lyWac.waitForAllReturnWhenError)(queries);
}

});

parcelRegister("6anVB", function(module, exports) {

$parcel$export(module.exports, "preloadPageTree", () => $d25c822192ffc860$export$45a75125fd859f7b);

var $dYU3e = parcelRequire("dYU3e");
var $lyWac = parcelRequire("lyWac");

var $jN2WI = parcelRequire("jN2WI");

var $1AEey = parcelRequire("1AEey");

var $6mKj3 = parcelRequire("6mKj3");

var $1oGPE = parcelRequire("1oGPE");

var $inLKs = parcelRequire("inLKs");
async function $d25c822192ffc860$export$45a75125fd859f7b({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '' }) {
    const promises = [
        $d25c822192ffc860$export$75e59f1581543cac({
            spaceKey: spaceKey,
            statuses: statuses,
            isSuperAdmin: isSuperAdmin,
            contentId: contentId
        }),
        (0, $1AEey.preloadUserState)(),
        (0, $jN2WI.preloadFooterCreateButton)(spaceKey)
    ];
    return (0, $lyWac.waitForAllReturnWhenError)(promises);
}
async function $d25c822192ffc860$export$75e59f1581543cac({ spaceKey: spaceKey, statuses: statuses, isSuperAdmin: isSuperAdmin, contentId: contentId = '' }) {
    // only fetch using PageTreeWithSpaceKeyQuery if contentId does not exist AND FF is enabled (only for SSR space overviews).
    // This is to differentiate between other use cases where contentId is not passed (according to prop types, it is an optional param)
    if (spaceKey && !contentId) {
        const { data: data } = await (0, $dYU3e.query)({
            query: (0, $inLKs.PageTreeWithSpaceKeyQuery),
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                // @ts-ignore
                ptStatuses: statuses,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                isReplacePagesWithPTPageEnabled: (0, $6mKj3.expVal)('cc_pages_to_ptpage_migration_experiment', 'isEnabled', false)
            }
        });
        if (data?.space?.homepageId && data?.space?.id) (0, $dYU3e.writeQuery)({
            query: (0, $inLKs.PageTreeQuery),
            variables: {
                spaceKey: spaceKey,
                isSuperAdmin: isSuperAdmin,
                statuses: statuses,
                // @ts-ignore
                ptStatuses: statuses,
                contentId: data?.space?.homepageId,
                paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
                isReplacePagesWithPTPageEnabled: (0, $6mKj3.expVal)('cc_pages_to_ptpage_migration_experiment', 'isEnabled', false)
            },
            data: {
                currentPage: data?.space?.pageTree || null,
                ...(0, $6mKj3.expVal)('cc_pages_to_ptpage_migration_experiment', 'isEnabled', false) ? {
                    ptpage: data?.ptpage || null
                } : {
                    rootLevelPages: data?.rootLevelPages || null
                },
                space: data?.space ? {
                    id: data?.space?.id,
                    homepage: {
                        id: data?.space?.homepageId,
                        // @ts-ignore
                        __typename: 'Content'
                    },
                    operations: data?.space?.operations,
                    // @ts-ignore
                    __typename: 'Space'
                } : null
            }
        });
    } else await (0, $dYU3e.query)({
        query: (0, $inLKs.PageTreeQuery),
        variables: {
            spaceKey: spaceKey,
            isSuperAdmin: isSuperAdmin,
            statuses: statuses,
            ptStatuses: statuses,
            ...contentId && {
                contentId: contentId
            },
            paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
            isReplacePagesWithPTPageEnabled: (0, $6mKj3.expVal)('cc_pages_to_ptpage_migration_experiment', 'isEnabled', false)
        }
    });
}

});
parcelRegister("jN2WI", function(module, exports) {

$parcel$export(module.exports, "preloadFooterCreateButton", () => $c0d8eea1db3e88bb$export$6b492303c3449855);

var $dYU3e = parcelRequire("dYU3e");

var $6mKj3 = parcelRequire("6mKj3");

var $3zNFE = parcelRequire("3zNFE");
function $c0d8eea1db3e88bb$export$6b492303c3449855(spaceKey) {
    if ((0, $6mKj3.expVal)('confluence_unified_space_preloader', 'isEnabled', false)) return Promise.resolve();
    return (0, $dYU3e.query)({
        query: (0, $3zNFE.FooterCreateButtonsQuery),
        variables: {
            errorPolicy: 'all',
            spaceKey: spaceKey
        }
    });
}

});

parcelRegister("1AEey", function(module, exports) {

$parcel$export(module.exports, "preloadUserState", () => $68018f140a0d9354$export$c54703ce1bd1f2a2);

var $jLfE2 = parcelRequire("jLfE2");
var $dYU3e = parcelRequire("dYU3e");

var $kZc3a = parcelRequire("kZc3a");
async function $68018f140a0d9354$export$c54703ce1bd1f2a2() {
    const { userId: userId } = await (0, $jLfE2.getPreloaderFnContext)();
    if (!userId) return;
    return (0, $dYU3e.query)({
        query: (0, $kZc3a.GetUserStateQuery)
    });
}

});


parcelRegister("5iG5Q", function(module, exports) {

$parcel$export(module.exports, "preloadBlogTree", () => $704f9f1df7736cb5$export$af00c4ac24735b9);

var $dYU3e = parcelRequire("dYU3e");

var $eiCiP = parcelRequire("eiCiP");

var $1UApO = parcelRequire("1UApO");

var $9wGTI = parcelRequire("9wGTI");

var $fnlEZ = parcelRequire("fnlEZ");

var $6DMfJ = parcelRequire("6DMfJ");
async function $704f9f1df7736cb5$var$isBlogTreeExpanded() {
    try {
        const entries = await (0, $eiCiP.preloadLocalStorage)();
        const sideNavExpandState = entries.find((entry)=>entry.key.endsWith((0, $1UApO.PERSISTED_KEYS_ON_SERVER).PERSISTED_SPACE_NAV_SECTIONS_EXPANDED_STATES));
        if (sideNavExpandState.value) {
            const expandedStates = JSON.parse(sideNavExpandState.value);
            if (expandedStates.blogTree) return true;
        }
    } catch  {
    // Return value might be malformed
    }
    return false;
}
const $704f9f1df7736cb5$export$af00c4ac24735b9 = async ({ spaceKey: spaceKey })=>{
    // blog tree is default collapsed, and is only expanded when user lands directly on a blog.
    // Or use explicity expanded the blog tree section
    const blogTreeQueryPromise = (0, $dYU3e.query)({
        query: (0, $fnlEZ.BlogTree),
        variables: {
            spaceKey: spaceKey,
            first: (0, $6DMfJ.PAGE_SIZE),
            statuses: (0, $6DMfJ.BLOG_STATUSES),
            orderBy: (0, $9wGTI.fg)('cc_complexit_fe_blogtree_metadata_sort') ? 'metadata.createdDate desc' : 'history.createdDate desc',
            metadataSort: (0, $9wGTI.fg)('cc_complexit_fe_blogtree_metadata_sort')
        }
    });
    // isBlogTreeExpanded() is much faster then blogTreeQueryPromise
    // If section is not expanded we don't wait for the blog tree query to finish
    return $704f9f1df7736cb5$var$isBlogTreeExpanded().then((expanded)=>{
        if (expanded) return blogTreeQueryPromise;
    });
};

});



parcelRegister("2JYae", function(module, exports) {

$parcel$export(module.exports, "useIsDesktop", () => $ea5e64ad86524752$export$e31fbf0af7c148e4);

var $bmTgR = parcelRequire("bmTgR");
const $ea5e64ad86524752$export$e31fbf0af7c148e4 = ()=>{
    return {
        isDesktop: (0, $bmTgR.isDesktop)()
    };
};

});


//# sourceMappingURL=FullPageEditorComponent.2ffc540d.js.map
